import React from "react";
import ReactTable from "react-table";
import { AutorizacionComisionMockUp } from "./AutorizacionComisiones.types";

interface Props {
  data: AutorizacionComisionMockUp[];
  onSelectionChange: (selected: AutorizacionComisionMockUp[]) => void;
  onExport: () => void;
}

export const AutorizacionComisionesTable: React.FC<Props> = ({
  data,
  onSelectionChange,
  onExport
}) => {
  const [selectedRows, setSelectedRows] = React.useState<Set<number>>(
    new Set()
  );

  const toggleRow = (index: number) => {
    const newSelected = new Set(selectedRows);
    if (newSelected.has(index)) {
      newSelected.delete(index);
    } else {
      newSelected.add(index);
    }
    setSelectedRows(newSelected);

    const selected = data.filter((_, i) => newSelected.has(i));
    onSelectionChange(selected);
  };

  const toggleAll = () => {
    if (selectedRows.size === data.length) {
      setSelectedRows(new Set());
      onSelectionChange([]);
    } else {
      setSelectedRows(new Set(data.map((_, i) => i)));
      onSelectionChange(data);
    }
  };

  const columns = [
    {
      Header: () => (
        <input
          type="checkbox"
          checked={selectedRows.size === data.length && data.length > 0}
          onChange={toggleAll}
        />
      ),
      accessor: "seleccionado",
      Cell: (row: any) => (
        <input
          type="checkbox"
          checked={selectedRows.has(row.index)}
          onChange={() => toggleRow(row.index)}
        />
      ),
      width: 50,
      filterable: false,
      sortable: false
    },
    {
      Header: "Membresía",
      accessor: "membresia"
    },
    {
      Header: "Tipo Membresía",
      accessor: "tipoMembresia"
    },
    {
      Header: "Tipo Comisión",
      accessor: "tipoComision"
    },
    {
      Header: "Alcance",
      accessor: "alcance"
    },
    {
      Header: "Monto",
      accessor: "monto",
      Cell: (row: any) => `$${row.value.toLocaleString()}`
    },
    {
      Header: "Empleado",
      accessor: "empleado"
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <button className="btn btn-primary" onClick={onExport}>
          Exportar CSV
        </button>
      </div>
      <ReactTable
        data={data}
        columns={columns}
        defaultPageSize={10}
        sortable={false}
        resizable={false}
        showPagination={false}
        className="-striped -highlight"
        previousText="Anterior"
        nextText="Siguiente"
        loadingText="Cargando..."
        noDataText="No hay registros"
        pageText="Página"
        ofText="de"
        rowsText="filas"
      />
    </div>
  );
};
